import { useEffect, useRef } from 'react';
import api from '../services/api';

const HEARTBEAT_INTERVAL_MS = 3 * 60 * 1000;

async function pingSession(): Promise<void> {
  try {
    await api.post('/auth/session/ping');
  } catch {
    // Ignore — token refresh / logout handles auth errors elsewhere
  }
}

/** Keeps session last_seen_at fresh and supports idle/disconnect duration tracking. */
export function useSessionHeartbeat(enabled: boolean): void {
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  useEffect(() => {
    if (!enabled) return;

    void pingSession();

    intervalRef.current = setInterval(() => {
      void pingSession();
    }, HEARTBEAT_INTERVAL_MS);

    const onVisible = () => {
      if (document.visibilityState === 'visible') {
        void pingSession();
      }
    };
    document.addEventListener('visibilitychange', onVisible);

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, [enabled]);
}
